import { DocumentNode, LazyQueryExecFunction, OperationVariables, useLazyQuery, useMutation } from '@apollo/client';

export const useAppLazyQuery = ({
  query,
  onCompleted,
}: {
  query: DocumentNode;
  onCompleted?: (data: any) => void;
}): [LazyQueryExecFunction<any, OperationVariables>, { data: any; loading: boolean }] => {
  const [fetcher, { data, loading: isLoading }] = useLazyQuery(query, {
    fetchPolicy: 'network-only',
    onCompleted: onCompleted,
  });
  return [fetcher, { data, loading: isLoading }];
};

export const useAppMutation = ({
  query,
  onCompleted,
}: {
  query: DocumentNode;
  onCompleted?: (data: any) => void;
}): [(options?: any) => Promise<any>, { data: any; loading: boolean }] => {
  const [mutateFunction, { data, loading: isLoading }] = useMutation(query, {
    fetchPolicy: 'network-only',
    onCompleted: onCompleted,
  });

  return [mutateFunction, { data, loading: isLoading }];
};
